export const ConsumerPhoneValidationResendCodeBannerInfoMessage = {
  message: {
    id: 'Pages.ConsumerPhoneValidation.ResendVerificationCode.message',
    description: 'We’ve resent the code, please check your phone',
  },
}
